export default __webpack_public_path__ + "static/Loft1-1-2787a176137a4dd514b4677f2b72aa59.jpg";